<template>
  <div class="talent"
       id="talenttop">
    <Topper></Topper>
    <div class="nei_tit">
      <img src="../assets/talent_tit.jpg"
           alt="">
      <span>人才激发</span>
    </div>
    <div class="talent_text">
      我们不仅是伙伴<br />
      更是成就彼此，共生共赢的事业合伙人<br />
      一起加入我们吧！
    </div>
    <div class="talent_link">
      <a href="https://enn.zhiye.com/"><img src="../assets/talent2.jpg"
             alt=""></a>
      <span>社会招聘</span>
    </div>
    <div class="talent_link">
      <a href="https://enn.zhiye.com/Campus"><img src="../assets/talent3.jpg"
             alt=""></a>
      <span>校园招聘</span>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Topper from "./Topper";
import Footer from './Footer.vue';
export default {
  components: {
    Topper,
    Footer
  },
  name: "talent",
  data () {
    return {
    };
  },
  methods: {
    loadUrl () {
      //跳锚点
      let maodian = this.$route.params.maodian;
      console.log(maodian);
      if (maodian) {
        this.$nextTick(() => {
          const targetElement = document.querySelector(maodian);
          window.scrollTo({ top: targetElement.offsetTop - 45, behavior: 'smooth' });
        })
      } else {
        window.scrollTo(0, 0);
      }
    }
  },
  mounted () {

    this.loadUrl();
  }
};
</script>

<style scoped>
.talent {
  background: #fff;
  width: 750px;
  height: auto;
  overflow: hidden;
}
.nei_tit {
  width: 750px;
  height: 450px;
  position: relative;
  margin-top: 95px;
}
.nei_tit img {
  width: 750px;
  height: 450px;
  position: absolute;
  left: 0;
  top: 0;
}
.nei_tit span {
  position: absolute;
  left: 40px;
  top: 200px;
  font-size: 48px;
  color: #fff;
  font-weight: 500;
}
.talent_text {
  width: 710px;
  height: 209px;
  background: url(../assets/talent1.jpg);
  background-size: 100% 100%;
  font-size: 36px;
  color: #003a77;
  text-align: left;
  padding-left: 40px;
  padding-top: 60px;
  float: left;
}
.talent_link {
  width: 750px;
  height: 500px;
  float: left;
  position: relative;
}
.talent_link img {
  width: 750px;
  height: 500px;
  position: absolute;
  left: 0;
  top: 0;
}
.talent_link span {
  font-size: 36px;
  color: #fff;
  display: block;
  width: 150px;
  position: absolute;
  left: 300px;
  top: 200px;
}
.talent_link span::after {
  content: '';
  display: block;
  width: 66px;
  height: 6px;
  background: #fff;
  margin: 15px auto;
}
</style>
